export const LABOR_PRODUCTIVITY_DASHBOARD_PATH = '/reports/labor-productivity';

export const CALLOUT_TYPE_COLORS: Record<string, string> = {
  casual: '#7E78B8',
  part_time: '#4A4580',
  full_time: '#2D2B55',
  flex: '#A89FE0',
};

export const EMPLOYMENT_TYPE_LABELS: Record<string, string> = {
  casual: 'Casual',
  part_time: 'Part Time',
  full_time: 'Full Time',
  flex: 'Flex',
};

export const VERTICAL_BAR_MAX_ITEMS = 15;

export const HORIZONTAL_BAR_RIGHT_MARGIN = 80;

export const DONUT_CHART_SIZE = 180;
export const DONUT_INNER_RATIO = 0.6;
